import { render, staticRenderFns } from "./IndustryOrganization.vue?vue&type=template&id=e0720c38"
import script from "./IndustryOrganization.vue?vue&type=script&lang=js"
export * from "./IndustryOrganization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports